class SignupUser {
  public name: string;
  public phonetic: string;
  public phone: string;
  public region: string;
  public city: string;
  public address1: string;
  public address2: string;
  public password: string;
  public passwordConfirmation: string;

  constructor({
    name,
    phonetic,
    phone,
    region,
    city,
    address1,
    address2,
    password,
    passwordConfirmation,
  }: {
    name?: string;
    phonetic?: string;
    phone?: string;
    region?: string;
    city?: string;
    address1?: string;
    address2?: string;
    password?: string;
    passwordConfirmation?: string;
  }) {
    this.name = name || '';
    this.phonetic = phonetic || '';
    this.phone = phone || '';
    this.region = region || '';
    this.city = city || '';
    this.address1 = address1 || '';
    this.address2 = address2 || '';
    this.password = password || '';
    this.passwordConfirmation = passwordConfirmation || '';
  }

  public toJson(): object {
    return {
      name: this.name,
      phonetic: this.phonetic,
      phone: this.phone,
      region: this.region,
      city: this.city,
      address1: this.address1,
      address2: this.address2,
      password: this.password,
      passwordConfirmation: this.passwordConfirmation,
    };
  }
}

export default SignupUser;
